import React from "react";
import { Modal, Button } from "react-bootstrap";
import { CONSTANTS } from "../constants/constants";
import { formateDate } from "../utils/util";

export default function DisplaySelectedPost({
  handleModalClose,
  showModal,
  item,
}) {
  return (
    <Modal show={showModal} onHide={handleModalClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {CONSTANTS.POST_DETAILS.POST_ID}
          {item.id}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h6>{CONSTANTS.POST_DETAILS.TITLE}</h6>
        {item.title}
      </Modal.Body>
      <Modal.Body>
        <h6>{CONSTANTS.POST_DETAILS.DESCRIPTION}</h6>
        {item.text}
      </Modal.Body>
      <Modal.Body>
        <h6>{CONSTANTS.POST_DETAILS.CREATED_AT}</h6>
        {formateDate(item.published_at)}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleModalClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
